import { render, staticRenderFns } from "./DomainActivityCard.vue?vue&type=template&id=44521b1c&"
import script from "./DomainActivityCard.vue?vue&type=script&lang=js&"
export * from "./DomainActivityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports